import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ActualiteDto } from "../../../../dto/GenApi.iNotPaie.Dto/ActualiteDto";

@Component
export default class ModalCardNews extends Vue {
	@Prop()
	public news: ActualiteDto[] = [];

	@Prop()
	public currentActu = 0;
}




// WEBPACK FOOTER //
// ./src/components/home/modals/modalCardNews/modalCardNews.ts